import { render, staticRenderFns } from "./PurchasesTask.vue?vue&type=template&id=5ba71d92&"
import script from "./PurchasesTask.vue?vue&type=script&lang=js&"
export * from "./PurchasesTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports